@if (reportType !== null && reportId !== null) {
  <div style="margin-top: 5em;">
    <div class="pBI-button">
      <ion-button color="secondary" type="button" (click)="goBack()">{{ 'Return' | translate }}</ion-button>
      <ion-button color="secondary"  type="button" (click)="pbiService.reload(); bookmarkaction = false; playbookmarkAction = false;">{{ 'Reload' | translate }}</ion-button>
      <ion-button color="secondary" (click)="setAsFavorite();">{{report?.UsersFavorite ? ('Remove Favorite' | translate) : ('Set as Favorite' | translate)}}</ion-button>
      @if (!onmobileView && reportType.localeCompare('report', undefined, { sensitivity: 'accent'}) === 0) {
        <ion-button color="secondary"   (click)="showPopOver($event);">{{ 'Choose Size' | translate }}</ion-button>
      }
      @if (!onmobileView) {
        <ion-button color="secondary" type="button" (click)="pbiService.showFullscreen()">{{ 'Fullscreen' | translate }}</ion-button>
      }
      @if (!onmobileView) {
        <ion-button color="secondary" type="button" (click)="pbiService.print()">{{ 'Print' | translate }}</ion-button>
      }
      @if (!onmobileView && (report?.AllowExport || $safeNavigationMigration(report?.AllowExport) === null || !report?.hasOwnProperty('AllowExport'))) {
        <ion-button color="secondary" type="button" (click)="exportFile($event)" [disabled]="exportingReportProcess">{{ 'Export File' | translate }}</ion-button>
      }
    </div>
    @if (showLoaderContainer) {
      <div id="pbi-loader-container">
        <pbi-loader id="pbi-loader"></pbi-loader>
        <div id="pbi-loader-text-1" class="pbi-loader-text">{{embedding ? ('Retrieving report' | translate) : loading ? ('Loading the data' | translate) : ('Rendering your visuals' | translate)}}...</div>
        <div id="pbi-loader-text-2" class="pbi-loader-text" style="visibility: hidden;">{{('Rendering your visuals' | translate)}}...</div>
      </div>
    }
    @if (embeddingReport) {
      <div class="embedding-powerBI" style="width: 100%;" id="reportContainer"></div>
    }
    <!-- <div *ngIf='!embeddingReport' class="embedding-powerBI" style="width: 100%;" id="dashboardContainer"></div> -->
  </div>
}

